'use strict';
import { BaseService } from '@narrate/base-sdk';

/**
 * retrieves the latest accessBlocks
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 * *
 *    await Core.api.homeFeed.list();
 */
class HomeFeedService extends BaseService {

  constructor() {
    super({ configPath: 'services.homefeed' });
  }

  async list() {
    const userLoggedIn = this.core.api.tokens ? this.core.api.tokens.id : false;

    const items = userLoggedIn
      ? await this.requestRootResource()
      : await this.requestRootResource({
        tokenType: 'none',
      });

    if (!items || !items.length) {
      return [];
    }

    // TODO consider putting this on the server side
    for (let item of items) {
      item.id = item.itemId.replace(/^access:/, "");
    }

    return items;
  }
}

export default HomeFeedService;
